import { Asset } from 'contentful'
import React from 'react'
import { Button } from '~/components/general/Button'
import { ResponsiveImage } from '~/components/ResponsiveImage'

interface CardItemProps {
  resume: {
    title: string
    slug: string
    examplePreview?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }
}

const CardItem: React.FC<CardItemProps> = ({ resume }) => {
  const title = resume.title.includes('Resume Example & Writing Guide')
    ? resume.title.replace('Resume Example & Writing Guide', '')
    : resume.title

  return (
    <>
      <div
        className="relative rounded-lg overflow-hidden mb-3 group"
        style={{
          boxShadow:
            '0px 2px 4px 0px rgba(15, 56, 113, 0.08), 0px 0px 1px 0px rgba(15, 56, 113, 0.40)',
        }}
      >
        {resume.examplePreview && (
          <ResponsiveImage
            asset={resume.examplePreview?.fields}
            opts={{ width: 256, load: 'lazy', alt: title }}
            style={{ minHeight: 'unset', objectFit: 'cover' }}
          />
        )}
        <Button
          className="!absolute !left-1/2 !top-1/2 !opacity-0 !text-xs group-hover:!opacity-100 max-w-[190px] -translate-x-1/2 !translate-y-1/2 transition-[opacity_.3s_ease]"
          text={'Use This Example'}
        />
      </div>
      <p className="text-s mb-1">{title}</p>
      <p className="text-neutral-40 text-s">Resume Example</p>
    </>
  )
}

export default CardItem
